import React from 'react'
import styled from 'styled-components'
import Display from '~shared/Display'
import { useStreamrTvBanner } from '../../contexts/StreamrTvBannerContext'
import { StreamrTvUrl } from '../../consts'

const Banner = styled.div`
    display: grid;
    grid-template-columns: 1fr auto;
    align-items: center;
    gap: 8px;

    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: ${(props) => props.bannerHeight}px;
    width: 100%;

    background: linear-gradient(270deg, #baa2c2 -0.14%, #7c8ab7 74.86%, #2d4c8a 99.86%);
    border-radius: 0px;
    z-index: 10000;
`

const Text = styled.div`
    display: flex;
    align-items: center;
    font-family: 'IBM Plex Sans';
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #ffffff;
    padding: 0px 24px;
    opacity: ${(props) => (props.isVisible ? '1' : '0')};

    > a {
        color: #ffffff;
        text-decoration: none;
        display: inline-flex;
        align-items: center;
    }
`

const CloseIconWrapper = styled.div`
    align-self: center;
    justify-self: right;
    display: flex;
    padding-right: 16px;
    cursor: pointer;

    &:hover {
        opacity: 0.8;
    }

    opacity: ${(props) => (props.isVisible ? '1' : '0')};
`

const CloseIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none">
            <path
                stroke="#fff"
                strokeLinecap="round"
                strokeWidth="1.5"
                d="m21 11.07-10 10M11 11.07l10 10"
            />
        </svg>
    )
}

const LinkIconWrapper = styled.div`
    display: inline-flex;
    align-items: center;
    margin-left: 8px;
    cursor: pointer;
`

const LinkIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none">
            <rect width="20" height="20" fill="#fff" fillOpacity=".2" rx="10" />
            <path
                fill="#fff"
                fillRule="evenodd"
                d="M7.813 6.7c0-.26.21-.47.468-.47h5c.26 0 .469.21.469.47v5a.469.469 0 1 1-.938 0V7.167h-4.53a.469.469 0 0 1-.47-.469Z"
                clipRule="evenodd"
            />
            <path
                fill="#fff"
                fillRule="evenodd"
                d="M13.613 6.368a.469.469 0 0 1 0 .663l-6.875 6.875a.469.469 0 0 1-.663-.663l6.875-6.875a.469.469 0 0 1 .663 0Z"
                clipRule="evenodd"
            />
        </svg>
    )
}

const StreamrTvBanner = () => {
    const { isVisible, shouldRender, closeBanner, bannerHeight } = useStreamrTvBanner()

    if (!shouldRender) {
        return null
    }

    return (
        <Banner isVisible={isVisible} bannerHeight={bannerHeight}>
            <Text isVisible={isVisible}>
                {/* eslint-disable-next-line react/jsx-no-target-blank */}
                <a href={StreamrTvUrl} target="_blank">
                    <Display mobile="none" tablet="block">
                        StreamrTV is live – Start your broadcast now!
                    </Display>
                    <Display mobile="block" tablet="none">
                        StreamrTV is live!
                    </Display>{' '}
                    <LinkIconWrapper>
                        <LinkIcon />
                    </LinkIconWrapper>
                </a>
            </Text>
            <CloseIconWrapper isVisible={isVisible} onClick={closeBanner}>
                <CloseIcon />
            </CloseIconWrapper>
        </Banner>
    )
}

export default StreamrTvBanner
